module.exports = __webpack_public_path__ + "img/MDI-link-box-outline.53a631c3.svg";